import React from "react";
import { useParams } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { Content, SubContent, Main } from "../../../components/Layout";
import MenuTrainee from "../../../components/MenuTrainee";
import AttendanceChat from "../../../components/AttendanceChat";

export default function Mensagem() {
  const { messageId } = useParams();
  return (
    <Main>
      <Content noBG="true">
        <Row>
          <Col md={12} lg={2}>
            <MenuTrainee />
          </Col>
          <Col>
            <SubContent>
              <AttendanceChat id={messageId} />
            </SubContent>
          </Col>
        </Row>
      </Content>
    </Main>
  );
}
